import { useCallback, useMemo } from 'react';

import { queryClient } from '@/shared/config';

import { CLIENT_STORAGE_QUERY_KEYS } from '../lib/constants';
import { useClientStorageItem } from './useClientStorageItem';

type UseClientStorageFlagOptions = {
  enabled?: boolean;
};

type UseClientStorageFlagResult = {
  hasShown: boolean;
  isLoading: boolean;
  markAsShown: () => void;
};

export const useClientStorageFlag = (
  key: string,
  options: UseClientStorageFlagOptions = {},
): UseClientStorageFlagResult => {
  const { enabled = true } = options;

  const { data, isLoading, setItem } = useClientStorageItem(key, { enabled });

  const hasShown = useMemo(() => {
    return data?.value === 'true';
  }, [data]);

  const markAsShown = useCallback(() => {
    queryClient.setQueryData(CLIENT_STORAGE_QUERY_KEYS.item(key), {
      key,
      value: 'true',
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    });

    setItem('true');
  }, [key, setItem]);

  return {
    hasShown,
    isLoading,
    markAsShown,
  };
};
